import {
    IconChevronLeftRegular,
    NavigationBar,
    skinVars,
    Text2,
    ThemeVariant,
    useWindowSize,
} from '@telefonica/mistica';
import { t } from 'i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { isWebviewAndroid, isWebviewIOS } from '../../utils/navigation/controlDevices';
import './index.scss';
import BreadCrumbsWrapper from '../BreadcrumbsWrapper';

interface BreadcrumbsItem {
    title: string;
    url: string;
}

const HeaderProfile = ({ breadcrumbs, title }: { breadcrumbs: BreadcrumbsItem[]; title: string }) => {
    const size = useWindowSize();
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const isFeedback = pathname.includes('/feedback/contacts/validate');

    return (
        <div
            className='headerProfile-component'
            style={{ background: size.width >= 1024 ? skinVars.colors.background : '' }}
        >
            {!(isWebviewAndroid || isWebviewIOS) && (
                <>
                    {!isFeedback && (
                        <div className='headerProfile-component__navigationBar'>
                            <NavigationBar
                                onBack={() => {
                                    navigate(-1);
                                }}
                                title={t(title)}
                            />
                        </div>
                    )}
                    <div
                        className='headerProfile-component__return'
                        onClick={() => {
                            navigate(-1);
                        }}
                    >
                        <div className='headerProfile-component__return-icon'>
                            <IconChevronLeftRegular color={skinVars.colors.neutralHigh} size={20} />
                        </div>
                        <Text2 medium color={skinVars.colors.neutralHigh}>
                            {t('returnResponsive')}
                        </Text2>
                    </div>
                </>
            )}
            <div className='headerProfile-component__breadcrumbs'>
                <ThemeVariant>
                    <BreadCrumbsWrapper title={t(title)} breadcrumbs={breadcrumbs} />
                </ThemeVariant>
            </div>
        </div>
    );
};

export default HeaderProfile;
